var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container-fluid"},[(_vm.loading && _vm.found.length === 0)?_c('div',[_c('Loading')],1):_vm._e(),(_vm.found.length > 0)?_c('AmbiguousHash',{attrs:{"entries":_vm.found}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }